import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1275223c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "person-name-highlight" }
const _hoisted_2 = { class: "visual" }
const _hoisted_3 = { class: "name-badge" }
const _hoisted_4 = { class: "highlight-text" }

import { computed } from 'vue'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { HighlightItem } from './HighlightItem'


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonNameHighlight',
  props: {
    highlight: {}
  },
  setup(__props: any) {

const props = __props;



const viewPersonStore = useViewPersonStore()

const relatedRef = computed(() => viewPersonStore.getAsyncPerson(props.highlight.personId)?.data)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (relatedRef.value)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: relatedRef.value.pageUrl!
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(props.highlight.value), 1)
            ]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(props.highlight.text), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
}
}

})